/*
 * @Author: your name
 * @Date: 2022-03-09 11:21:40
 * @LastEditTime: 2022-05-05 15:00:42
 * @LastEditors: Please set LastEditors
 * @Description: 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 * @FilePath: \pscd-portal-middle-office\packages\www\src\components\inject\extendsFields\smscode\index.tsx
 */
import { ProFormFieldProps } from '@ant-design/pro-form/es/components/Field';
import { BindAll } from 'lodash-decorators';
import { inject, observer } from 'mobx-react';
import React from 'react';
import styles from './style.module.less';
@inject(store => store)
@observer
@BindAll()
export class Fields_smscode extends React.Component<ProFormFieldProps & {
  phoneName?: string,
  phone?: string,
  scene: Number, //场景 ：1：注册；2：短信登录；3：修改密码；4：修改手机号
  formState: any,
  onClearImgCode: (isClear?) => {},
  [key: string]: any
}> {
  state = { countDown: 60, timer: null }
  get Currency() {
    return this.$Store.Currency;
  }
  get formState() {
    return this.props.formState
  }
  get phoneName() {
    return this.props.phoneName || 'mobile'
  }
  get scene() {
    return this.props.scene
  }

  // 获取短信验证码
  async onGetCaptcha(phone) {
    if (!this.formState.imgCode) {
      React.Antd.message.warning('请输入图形验证码！')
      throw new Error("请输入图形验证码")
    }
    try {
      if(this.props.onSendMsg) {
        await this.props.onSendMsg({
          imgCode: this.formState.imgCode,
          imgSession: this.formState.imgSession
        })
      } else {
        const res = await this.Currency.sendCode({
          endpoint: this.props.phone || phone,
          imgCode: this.formState.imgCode,
          receiverType: React.$Mamba.EnumCaptchaType.mobile,
          scene: this.scene,
          imgSession: this.formState.imgSession,
          t: this.formState.t
        })
        React.Antd.message.success(`获取验证码成功${res ? res : ''}`)
      }
      setTimeout(() => {
        this.props.onClearImgCode()
      }, this.state.countDown * 1000);

    } catch (error) {
      this.props.onClearImgCode(true)
      throw new Error("获取验证码错误")
    }
  }

  componentDidMount() {
    console.log("LENG ~ captcha ~ componentDidMount", this.props)
  }
  render() {
    return (
      <div className={styles.captchaGroup}>
        <div className={styles.captcha}>
          <React.Antd.ProFormCaptcha
            countDown={this.state.countDown}
            placeholder={'请输入验证码'}
            captchaProps={{
              type: 'primary',
              ghost: true
            }}
            captchaTextRender={(timing, count) => {
              if (timing) {
                return `${count} ${'s后重新获取'}`;
              }
              return '获取验证码';
            }}
            phoneName={this.phoneName}
            onGetCaptcha={async (phone) => {
              await this.onGetCaptcha(phone)
            }}
            {...this.props as any}
          />
        </div>
      </div>
    )
  }
}
